import { useCallback } from "react";

import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { ModifiedMapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { FILTER_ENTITY_TYPES } from "@app/component/filtering/components/MapFilterButton/utils/consts";
import useMapView from "@app/component/view/utils/useMapView";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

// clears filters for all fields except skipFields
const useClearMapFilters = (skipFields?: IField[]) => {
  const { updateFilterModel, updateViewAs } = useMapView();

  return useCallback(() => {
    const skipFieldsFilterNames = new Set((skipFields ?? []).map(({ filterName }) => filterName));
    const res = FILTER_ENTITY_TYPES.reduce<ModifiedMapFilterModel>((result, entityType) => {
      const fieldModel = getFieldModelByEntityType(entityType);

      let processedFilters = fieldModel.fields.reduce<Partial<FilterModel>>(
        (result, field) =>
          skipFieldsFilterNames.has(field.filterName)
            ? result
            : Object.assign(result, { [field.filterName]: undefined }),
        {}
      );

      // if all are fields are undefined and none of them is in skipped list, mark whole entityType as empty
      if (
        !fieldModel.fields.some((field) => skipFieldsFilterNames.has(field.name)) &&
        Object.keys(processedFilters).every((fieldName) => !processedFilters[fieldName])
      ) {
        processedFilters = {};
      }

      return Object.assign(result, {
        [entityType]: Object.keys(processedFilters).length ? processedFilters : undefined,
      });
    }, {});
    updateFilterModel(res);
    updateViewAs(undefined);
  }, [skipFields, updateFilterModel, updateViewAs]);
};

export default useClearMapFilters;
